import Tooltip from "../../../components/common/tooltip/tooltip"
import { Button, Dropdown, Tag } from "components/common"
import { useLazyGetClientCellsQuery, useLazyGetExternalClientCellsQuery } from "features/shared/api"
import { ACTION_TYPES } from "utils/gtm/gtmEventsData"
import { fireEvent } from "utils/gtm/gtmEventHandler"
import { useMemo } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

const WhatsappCallButton = props => {
  const { t } = useTranslation()
  const { client, disabled, leadId, from, preFetchedNumber = false, message = "", ...buttonProps } = props
  const userInfo = useSelector(state => state.app.user?.info)
  const [getClientCellInfo, { data: clientCells, isFetching: fetchClientCell }] = useLazyGetClientCellsQuery()
  const [getExternalClientInfo, { data: externalCells, isFetching: fetchExternalClientCell }] =
    useLazyGetExternalClientCellsQuery()

  const callOnWhatsapp = (cellNumber, id) => {
    window.open(`https://web.whatsapp.com/send?phone=${cellNumber}&text=${encodeURIComponent(message)}`)
    fireEvent({
      ...ACTION_TYPES.whatsapp_contact_client,
      user_input: cellNumber,
      client_id: client?.id,
      ...(leadId && { lead_id: leadId }),
      ...from,
    })
  }

  const onClick = e => {
    e.domEvent.stopPropagation()
    callOnWhatsapp(preFetchedNumber || clientCells?.[e.key]?.number, client?.id)
  }

  const onCopy = e => {
    e.preventDefault()
  }
  const onContextMenu = e => {
    e.preventDefault()
  }

  const items = useMemo(() => {
    if (preFetchedNumber) {
      return [{ label: preFetchedNumber, key: "preFetched" }]
    }

    return (from === "external" ? externalCells : clientCells)?.map((e, index) => {
      if (from === "external") return { label: e, key: index }
      else {
        return {
          label: (
            <div className="d-flex flexYcenter" style={{ gap: "6px" }}>
              {e.number}
              <Tooltip title={e.lastUsedDateTime}>
                <Tag pill style={{ color: "#0091ba", "--tag-bg": "#E6F5F9" }}>
                  {e.lastUsed}
                </Tag>
              </Tooltip>
            </div>
          ),
          key: index,
        }
      }
    })
  }, [clientCells, externalCells, from, preFetchedNumber])

  return (
    <Dropdown
      menu={{ items, onClick, onCopy, onContextMenu }}
      dropdownRender={menu => (items?.length ? <div className="dropdown-content">{menu}</div> : <></>)}
      placement="bottomLeft"
      suffixIcon=""
      disabled={disabled}
    >
      <Button
        icon={"RiWhatsappFill"}
        iconProps={{ size: "1.4em" }}
        loading={!preFetchedNumber && (fetchClientCell || fetchExternalClientCell)}
        onClick={e => {
          e.stopPropagation()
          if (!preFetchedNumber) {
            from === "external"
              ? getExternalClientInfo({ clientId: client?.id, actionType: "tooltip", type: "whatsapp" })
              : getClientCellInfo({ clientId: client?.id, actionType: "tooltip&includeLastUsed=true" })
          }
        }}
        content={t("WhatsApp")}
        color="#3eaf4c"
        shape="circle"
        type="light"
        disabled={!userInfo?.AgencyConfiguration?.Platform?.platformKey === "zameen" || disabled}
        {...buttonProps}
      />
    </Dropdown>
  )
}

export default WhatsappCallButton
